export type ComparisonColumnLoadState = {
    readonly error: Error | null;
    readonly isInitialLoading: boolean;
};

export const getComparisonContentState = ({
    columns,
    sectionRowCount,
    skillRowCount,
    taskCount = 0,
}: {
    readonly columns: readonly ComparisonColumnLoadState[];
    readonly sectionRowCount: number;
    readonly skillRowCount: number;
    readonly taskCount?: number;
}): { readonly isEmpty: boolean; readonly showLoadingRows: boolean } => {
    const hasInitialLoading = columns.some(({ isInitialLoading }) => isInitialLoading);
    const hasErrors = columns.some(({ error }) => error !== null);
    const hasRows = sectionRowCount > 0 || skillRowCount > 0 || taskCount > 0;

    return {
        isEmpty: columns.length === 0 || (!hasInitialLoading && !hasErrors && !hasRows),
        showLoadingRows: hasInitialLoading && !hasRows,
    };
};
